var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"404"}},[_c('h3',{staticClass:"mb-4"},[_vm._v("404 error")]),_vm._v(" 抱歉，此頁面不存在！"),_c('br'),_vm._v(" 請返回上一頁，或點選上方連結觀看其他頁面。 ")])
}]

export { render, staticRenderFns }